var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDisconnectedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 82 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.561 48.63a3.53 3.53 0 014.992 0l11.979 11.979 11.98-11.98a3.53 3.53 0 014.991 4.992L46.523 65.6l11.98 11.979a3.53 3.53 0 01-4.991 4.991l-11.98-11.98-11.98 11.98a3.53 3.53 0 01-4.99-4.991L36.54 65.6 24.561 53.62a3.53 3.53 0 010-4.99z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.243 5.94c5.178-2.853 13-4.76 23.464-5.72C36.774.075 38.849 0 40.931 0s4.327.074 6.733.22c8.004.3 15.186 1.975 21.546 5.027 4.796 2.302 8.374 5.025 10.733 8.171a9.6 9.6 0 011.92 5.76v4.919a7.245 7.245 0 01-7.246 7.245c-2.84 0-6.633-.775-11.38-2.325a6.4 6.4 0 01-4.333-5.065l-.91-5.645a3.2 3.2 0 00-1.975-2.463c-4.7-1.873-10.178-2.81-16.433-2.81-6.088 0-10.919.901-14.492 2.704a3.2 3.2 0 00-1.738 2.495l-.607 5.328a6.4 6.4 0 01-4.553 5.415c-5.362 1.577-9.265 2.366-11.709 2.366A6.488 6.488 0 010 24.854V19.4a9.6 9.6 0 012.042-5.92c2.271-2.9 5.338-5.413 9.201-7.54z",
    fill: "#fff"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectedIcon);
export default __webpack_public_path__ + "static/media/DisconnectedIcon.393a9953ad099052284d6200508eea2a.svg";
export { ForwardRef as ReactComponent };